import { Row, Col, Flex } from "antd";
import React, { useEffect, useState } from "react";
import { recruiterVisibleStatuses, IJob, ProjectsMainWrapper } from "../RecruitersPanel/helper";
import { ApplicantsListPanel } from "./applicantsPanel";
import { useNavigate, useSearchParams } from "react-router-dom";
import PageHeading from "./pageHeading";
import { axiosInstant, endpoints } from "../../api";
import ProjectList from "./projectsPanel/projectList";
import { showError } from "../../Notifications";
import BackBtn from "../backBtn";
import { Table } from "antd";
import axios from "axios";

interface ManagersPanelProps {
  managerEmail: string;
}

export const ManagersPanel: React.FC<ManagersPanelProps> = ({ managerEmail }) => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [jobsList, setjobsList] = useState<Array<IJob>>([]);
  const [selectedJob, setSelectedJob] = useState<IJob>();

  useEffect(() => {
    axiosInstant.get(`${process.env.REACT_APP_API_BASE_URL}/jobs/manager/my-jobs`, { params: { email: managerEmail } })
      .then(async res => {
        const jobs = res.data;
        console.log('[Manager] my-jobs for email:', managerEmail, '→', jobs.length, 'jobs', jobs.map((j: any) => j.positionTitle));
        const jobsWithCounts = await Promise.all(
          jobs.map(async (job: IJob) => {
            try {
              const res = await axiosInstant.get(`/job-applications/applications/by-job/${job._id}`);
              const applicants = Array.isArray(res.data) ? res.data : [];
              console.log('[Manager] job:', job.positionTitle, '→ all apps:', applicants.map((a: any) => ({ status: a.status, id: a._id })));
              const visibleApplicants = applicants.filter(app => recruiterVisibleStatuses.includes(app.status ?? ""));
              console.log('[Manager] job:', job.positionTitle, '→ visible apps:', visibleApplicants.length);
              return { ...job, totalApplicants: visibleApplicants.length };
            } catch {
              return { ...job, totalApplicants: 0 };
            }
          })
        );
        setjobsList(jobsWithCounts);
      })
      .catch(err => console.error('[Manager] failed to load jobs:', err));
  }, [managerEmail]);

  useEffect(() => {
    if (!jobsList.length) return;
    const jobParam = searchParams.get("job") || -1;
    const job = jobsList.find((e) => e._id === jobParam);
    if (job) setSelectedJob(job);
    else {
      setSelectedJob(undefined);
      setSearchParams((params) => {
        params.delete("job");
        return params;
      });
    }
  }, [jobsList, searchParams, setSearchParams]);

  return (
    <Row>
      <Col span={24}>
        <Flex vertical style={{
          ...ProjectsMainWrapper,
          fontSize: '16px'
        }}>
          {selectedJob && <BackBtn />}
          <PageHeading job={selectedJob} />
          {selectedJob ? (
            <ApplicantsListPanel job={selectedJob} />
          ) : (
            <ProjectList list={jobsList} />
          )}
        </Flex>
      </Col>
    </Row>
  );
};

export default ManagersPanel;
